import React from "react";
import "./VideosRowItem.css";
import "./VideoPlayerItem.css";
import ReactHlsPlayer from 'react-hls-player';
import {useRef} from "react";

function ShowLiveStream(props) {
  const player = useRef();
  if(props.playbackURL != null) {
    return (
      <ReactHlsPlayer
        className="videoItem-LiveStream"
        src={props.playbackURL}
        autoPlay={true}
        muted={true}
        controls={true}
        width="100%"
        height="auto"
        hlsConfig={{
          liveSyncDurationCount: 1
        }}
        playerRef={player}
        onTimeUpdate={async () => {
          await props.logMinuteAttended(player)
        }}
      />
    );
  } else {
    return (
      <ReactHlsPlayer
        className="videoItem-LiveStream"
        src={`https://lvpr.tv?v=${props.playbackId}`}
        autoPlay={true}
        muted={true}
        controls={true}
        width="100%"
        height="auto"
        playerRef={player}
        onTimeUpdate={async () => {
          await props.logMinuteAttended(player)
        }}
      />
    );
  }
}

export default React.memo(ShowLiveStream);